<canvas id="canvas-main" style="width: 100%; border: 1px solid black;" height="200"></canvas>